import { render, staticRenderFns } from "./MonsterBasicInfo.vue?vue&type=template&id=a22ada10&scoped=true&"
import script from "./MonsterBasicInfo.vue?vue&type=script&lang=ts&"
export * from "./MonsterBasicInfo.vue?vue&type=script&lang=ts&"
import style0 from "./MonsterBasicInfo.vue?vue&type=style&index=0&id=a22ada10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22ada10",
  null
  
)

export default component.exports